// Two titles. A book without a `cover` falls back to the typographic
// placeholder specified in the handoff.

const BOOKS = [
	{
		id: "agentic",
		title: "Building Agentic AI Systems",
		subtitle:
			"Create intelligent, autonomous AI agents that can reason, plan, and adapt",
		cover: "/agentic-ai.jpg",
		coverAlt: "Building Agentic AI Systems, front cover",
		credit: "Packt Publishing · May 2025 · with Wrick Talukdar",
		creditShort: "Packt · 2025 · with W. Talukdar",
		description:
			"More than a year of research and development on generative AI agents, written down: decision-making frameworks, multi-step planning, tool integration, the coordinator–worker–delegator pattern for scale, and a full section on trust, safety and ethics.",
		accolade: "Amazon #1 best seller in AI",
		note: "ISBN 978-1803238753 · Second edition in progress with Packt",
		links: [
			{ label: "Amazon ↗", link: "https://a.co/d/gufkfb2" },
			{
				label: "Packt ↗",
				link: "https://www.packtpub.com/en-us/product/building-agentic-ai-systems-9781801079273",
			},
		],
	},
	{
		id: "ethics",
		title: "Generative AI Ethics, Privacy, and Security",
		subtitle:
			"A guide to generative AI, its ethical considerations, privacy measures, security strategies, and approaches",
		cover: "/gen_ai_privacy.jpg",
		coverAlt: "Generative AI Ethics, Privacy, and Security, front cover",
		credit: "BPB Publications · with Wrick Talukdar",
		creditShort: "BPB · with W. Talukdar",
		description:
			"A guide to generative AI and its ethical considerations, privacy measures, security strategies, and the approaches that hold under scrutiny.",
		links: [{ label: "Amazon ↗", link: "https://a.co/d/09Yw3IBu" }],
	},
];

export { BOOKS };
